import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-hiring-managers-popover',
  templateUrl: './hiring-managers-popover.component.html',
  styleUrls: ['./hiring-managers-popover.component.css']
})
export class HiringManagersPopoverComponent {

  @Input() requisitionInfo;
  @Input() isCorporateCompany;

  trackByIndex(index) {
    return index;
  }

}
